import React from 'react';

import PropTypes from 'prop-types';
import { stringToHslColor } from 'utils/helpers';
import { formatApplicantDate, getColumnStructureForPDF } from '../utils';
import { transparentize } from 'polished';
import { formatAddress } from 'utils/processFormUtil';
import { findGradeRemark } from '../ApplicantModals/NecoResult/necoUtils';
import Theme from 'utils/theme';
const moment = require('moment-timezone');

// use font

// Create styles
const styles = {
  page: {
    fontFamily: 'Helvetica',
    paddingBottom: 25,
  },
  applicant_info: {
    padding: '10px 24px',
  },
  title: {
    fontSize: "18px",
    display: 'block',
    textTransform: 'capitalize',
    fontFamily: 'Helvetica-Bold',
  },
  line: { width: '100%' },
  space: { marginBottom: 20 },
  data: {
    display: 'block',
  },
  applicant_detail: {
    display: 'flex',
    padding: '15px 24px',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  applicant_detail_info: {
    marginRight: 10,
    width: '75%',
  },
  applicant_detail_photo: {
    width: '25%',
  },
  applicant_detail_photo_container: {
    display: 'inline-block',
    padding: 8,
    border: '1px solid #D8D8E3',
    borderRadius: 5,
  },

  tags: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  tag: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 30,
    fontSize: 8,
    height: 18,
    padding: '2px 10px',
    margin: '4px 10px 8px 0px',
  },
  passport: {
    borderRadius: 5,
    width: 120,
  },
  application: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  application_info_left: {
    fontSize: "10px",
    textTransform: 'capitalize',
    fontFamily: 'Helvetica-Bold',
    fontWeight: 'bold',
    marginRight: '10px',
    width: '25%',
  },
  application_info_right: {
    fontSize: '10px',
    fontWeight: 700,
    maxWidth: '250px',
  },
  application_course_name: {
    fontSize: '10px',
    fontWeight: 700,
    maxWidth: '250px',
    lineHeight: 1.5,
  },
  application_detail: {
    backgroundColor: '#fff',
    padding: 24,
  },
  submitted_by: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 15,
  },
  submitted_by_text: {
    fontSize: '12px',
    textAlign: 'right',
  },
  applicant_infox: {
    maxWidth: 900,
    border: '1px solid #D8D8E3',
    borderRadius: 5,
  },
  applicant_infox_row: {
    padding: 10,
    borderBottom: '1px solid #D8D8E3 ',
  },
  form_header: {
    marginBottom: 20,
    fontSize: "12px",
    display: 'block',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  form_field_title: {
    display: 'block',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: '#9D9DB7',
    fontSize: "9px",
  },
  form_field_subtitle: {
    display: 'block',
    color: '#707070',
    fontSize: "9px",
    margin: '10px 0px 15px 0',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: "10px",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  status: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px',
    marginBottom: 10,
    width: '20%',
    backgroundColor: 'rgba(208,213,217,0.3)',
    borderRadius: 100,
  },
  indicator: {
    height: 7,
    width: 7,
    borderRadius: '50%',
    position: 'relative',
  },
  indicator_text: {
    fontSize: "10px",
    padding: '0px 5px',
    color: '#000000',
    textTransform: 'capitalize',
    marginLeft: 4.4,
    marginRight: 4.4,
  },
  neco_result: {
    padding: '10px 24px',
  },
  neco_info_container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  neco_info: {
    width: '33%',
  },
  applicant_org_logo: {
    display: 'inline-block',
    marginBottom: 10,
  },
  logo: {
    borderRadius: 5,
    width: 60,
  },
  school_info: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: 20,
  },
  school_info_name: {
    width: '180px',
    fontFamily: 'Helvetica-Bold',
    color: '#363435',
    fontSize: "14px",
    lineHeight: 1.5,
  },
  school_contact_text: {
    fontSize: '8px',
    color: '#707070',
    textAlign: 'right',
  },
  school_contact: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderRadius: 5,
  },
  tableRow: {
    display: 'flex',
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCol: {
    width: '25%',
    border: '1px solid #D8D8E3',
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    marginBottom: 5,
    fontSize: "10px",
  },
};

// Create Document Component
const ApplicationFormPdf = ({ data, pdfFormRef }) => {
  getColumnStructureForPDF(data?.formItem || []);

  const StatusProps = (status) => {
    let theStatus = { label: 'Pending', color: 'gray' };
    switch (status?.toLowerCase()) {
      case 'accepted':
        theStatus = { label: 'Approved', color: Theme.PrimaryGreen };
        break;
      case 'declined':
        theStatus = { label: 'Declined', color: Theme.PrimaryRed };
        break;
      case 'submitted':
        theStatus = { label: 'Processing', color: Theme.PrimaryBlue };
        break;
      default:
        theStatus = { label: 'Pending', color: 'gray' };
        break;
    }
    return theStatus;
  };

  return (
    <div ref={pdfFormRef}>
      <div size="A4" style={styles.page}>
        <div style={styles.applicant_info}>
          <div style={styles.applicant_info_details}>
            {/* Page Header */}
            <div style={styles.school_info}>
              <div>
                <div style={styles.applicant_org_logo}>
                  <img style={styles.logo} src={data?.org?.logoUrl} alt="logo" />
                </div>
                <div style={styles.school_info_name}>{data?.org?.name}</div>
              </div>

              <div style={styles.school_contact}>
                <div style={styles.school_contact_text}>
                  {data?.contacts ? data?.contacts[0]?.email : ''}
                </div>
                <div style={styles.school_contact_text}>
                  {data?.org?.address}
                </div>
              </div>
            </div>
            Status
            {StatusProps(data?.data?.status) && (
              <div style={styles.status}>
                <div
                  style={{
                    ...styles.indicator,
                    backgroundColor: StatusProps(data?.data?.status)?.color,
                  }}
                />
                <div style={styles.indicator_text}>
                  {StatusProps(data?.data?.status)?.label}
                </div>
              </div>
            )}
            <div style={styles.title}>{data?.data?.name}</div>
          </div>
        </div>

        <div style={styles.applicant_detail}>
          <div style={styles.applicant_detail_info}>
            <div style={styles.application}>
              <div style={styles.application_info_left}>
                Application number:
              </div>{' '}
              <div style={styles.application_info_right}>
                {data?.data?.applicationNumber}
              </div>
            </div>
            {(data?.data?.lastReviewed || data?.data?.lastReviewedBy) && (
              <div style={{ fontSize: "10px", marginBottom: 5 }}>
                Last Reviewed: {data?.data?.lastReviewed}{' '}
                {data?.data?.lastReviewedBy}
              </div>
            )}
            <div style={styles.application}>
              <div style={styles.application_info_left}>Application: </div>
              <div style={styles.application_info_right}>
                {data?.data?.applicationTitle}
              </div>
            </div>
            {/* <div style={styles.application}>
              <div style={styles.application_info_left}>
                {data?.alias?.course} Code:{' '}
              </div>
              <div style={styles.application_info_right}>
                {data?.data?.course?.code}
              </div>
            </div> */}
            <div style={styles.application}>
              <div style={styles.application_info_left}>
                {data?.alias?.course}:{' '}
              </div>
              <div style={styles.application_course_name}>
                {data?.data?.course?.title}
              </div>
            </div>

            {data?.data?.regDate && (
              <div style={styles.application}>
                <div style={styles.application_info_left}>Registered Date</div>
                <div style={styles.application_info_right}>
                  {data?.data?.regDate}
                </div>
              </div>
            )}

            <div style={styles.tags}>
              {data?.data?.tags?.map((tag, i) => (
                <div
                  key={i}
                  style={{
                    ...styles.tag,
                    backgroundColor: stringToHslColor(tag?.label, 40, 84),
                    color: stringToHslColor(tag?.label, 20, 20),
                  }}
                >
                  <div>{tag?.label}</div>
                </div>
              ))}
            </div>
          </div>
          {/* Image */}
          <div style={styles.applicant_detail_photo}>
            {data?.formItemData?.passport_picture && (
              <div style={styles.applicant_detail_photo_container}>
                <img
                  style={styles.passport}
                  src={data?.formItemData?.passport_picture}
                  alt='passprt'
                />
              </div>
            )}
          </div>
        </div>

        <div style={styles.application_detail}>
          {data?.data?.accountEmail && (
            <div style={styles.submitted_by}>
              <div style={styles.submitted_by_text}>
                Submitted By: {data?.data?.accountEmail}
              </div>
            </div>
          )}
          <div style={styles.applicant_infox}>
            {data?.formItem
              ?.filter((item) => +item.inputs?.length > 0)
              .filter(
                (item) => item?.refereeSectionType?.toLowerCase() !== 'referee'
              )
              .map((item, i) => (
                <div
                  style={{
                    ...styles.applicant_infox_row,
                    backgroundColor:
                      i % 2 !== 0
                        ? transparentize(0.4, '#F5F5F7')
                        : 'transparent',
                    borderBottom: i === data?.formItem.length - 1 ? 0 : 1,
                    borderColor:
                      i === data?.formItem.length - 1
                        ? 'transparent'
                        : '#D8D8E3',
                  }}
                  key={i}
                >
                  <div style={styles.form_header}>{item?.title}</div>
                  {item?.inputs?.map((eachRow, rowIndex) => (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'space-evenly',
                      }}
                      key={`row-${rowIndex}`}
                    >
                      {eachRow?.map((eachField, i) => (
                        <div style={{ flex: 1, marginRight: 10 }} key={i}>
                          {eachField?.title && (
                            <>
                              <div style={styles.form_field_title}>
                                {eachField?.title}
                              </div>
                              {eachField?.source === 'nigeria-states-lga' ? (
                                <div
                                  style={{
                                    ...styles.form_field_subtitle,
                                    textTransform: !![
                                      'email',
                                      'wysiwyg',
                                    ].includes(eachField?.type?.toLowerCase())
                                      ? 'capitalize'
                                      : 'none',
                                  }}
                                >
                                  {formatAddress(
                                    data?.formItemData?.[eachField?.id]
                                  )}
                                </div>
                              ) : (
                                <div
                                  style={{
                                    ...styles.form_field_subtitle,
                                    textTransform: ![
                                      'email',
                                      'wysiwyg',
                                    ].includes(eachField?.type?.toLowerCase())
                                      ? 'capitalize'
                                      : 'none',
                                  }}
                                >
                                  {eachField?.type === 'checkbox' ? (
                                    <>
                                      {data?.formItemData?.[eachField.id]
                                        ? eachField.trueDisplay
                                        : eachField.falseDisplay}
                                    </>
                                  ) : (
                                    <>
                                      {eachField?.type?.toLowerCase() ===
                                        'date' &&
                                      data?.formItemData?.[eachField?.id]
                                        ? moment(
                                            formatApplicantDate(
                                              data?.formItemData?.[
                                                eachField?.id
                                              ]
                                            )
                                          ).format('MMMM Do YYYY')
                                        : data?.formItemData?.[eachField?.id] ||
                                          '--/--'}
                                    </>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>

        {data?.necoInfo?.map((neco, i) => (
          <div style={styles.neco_result} key={i}>
            <div
              style={{
                ...styles.form_header,
                marginTop: 20,
              }}
            >
              NECO RESULT {i + 1 > 1 ? `(${i + 1}ND SITTING)` : ''}
            </div>
            {neco?.result?.passportUrl && (
              <div style={styles.applicant_detail_photo}>
                <div style={styles.applicant_detail_photo_container}>
                  <img
                    style={styles.passport}
                    src={JSON.parse(neco?.result?.passportUrl)}
                    alt='passport'
                  />
                </div>
              </div>
            )}
            <div style={styles.neco_info_container}>
              <div style={styles.neco_info}>
                <span style={styles.form_field_title}>First Name</span>
                <span
                  style={{
                    ...styles.form_field_subtitle,
                    textTransform: 'capitalize',
                  }}
                >
                  {neco?.result?.firstName || '--/--'}
                </span>
              </div>
              <div style={styles.neco_info}>
                <span style={styles.form_field_title}>Middle Name</span>
                <span
                  style={{
                    ...styles.form_field_subtitle,
                    textTransform: 'capitalize',
                  }}
                >
                  {neco?.result?.middleName || '--/--'}
                </span>
              </div>
              <div style={styles.neco_info}>
                <span style={styles.form_field_title}>Last Name</span>
                <span
                  style={{
                    ...styles.form_field_subtitle,
                    textTransform: 'capitalize',
                  }}
                >
                  {neco?.result?.lastName || '--/--'}
                </span>
              </div>
            </div>
            <div style={styles.neco_info_container}>
              <div style={styles.neco_info}>
                <span style={styles.form_field_title}>Registration Number</span>
                <span
                  style={{
                    ...styles.form_field_subtitle,
                    textTransform: 'capitalize',
                  }}
                >
                  {neco?.result?.registrationNumber || '--/--'}
                </span>
              </div>
              <div style={styles.neco_info}>
                <span style={styles.form_field_title}>Gender</span>
                <span
                  style={{
                    ...styles.form_field_subtitle,
                    textTransform: 'capitalize',
                  }}
                >
                  {neco?.result?.gender?.toUpperCase() === 'M'
                    ? 'Male'
                    : 'Female' || '--/--'}
                </span>
              </div>
            </div>

            <div style={styles.table}>
              <div style={styles.tableRow}>
                <div style={styles.tableCol}>
                  <span style={styles.tableCell}>S/N</span>
                </div>
                <div style={styles.tableCol}>
                  <span style={styles.tableCell}>Subject</span>
                </div>
                <div style={styles.tableCol}>
                  <span style={styles.tableCell}>Grade</span>
                </div>
                <div style={styles.tableCol}>
                  <span style={styles.tableCell}>Remark</span>
                </div>
              </div>
              {neco?.result?.subjects?.map((subject, i) => (
                <div style={styles.tableRow} key={i}>
                  <div style={styles.tableCol}>
                    <span
                      style={{
                        ...styles.tableCell,
                        ...styles.form_field_title,
                      }}
                    >
                      {i + 1}
                    </span>
                  </div>
                  <div style={styles.tableCol}>
                    <span
                      style={{
                        ...styles.tableCell,
                        ...styles.form_field_title,
                        textTransform: 'capitalize',
                      }}
                    >
                      {subject.name} ({subject.shortName})
                    </span>
                  </div>
                  <div style={styles.tableCol}>
                    <span
                      style={{
                        ...styles.tableCell,
                        ...styles.form_field_title,
                        textTransform: 'capitalise',
                      }}
                    >
                      {subject.grade}
                    </span>
                  </div>
                  <div style={styles.tableCol}>
                    <span
                      style={{
                        ...styles.tableCell,
                        ...styles.form_field_title,
                        textTransform: 'capitalise', 
                      }}
                    >
                      {findGradeRemark(subject.grade)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </div>
    </div>
  );
};

export default ApplicationFormPdf;

ApplicationFormPdf.propTypes = {
  data: PropTypes.object,
};
